import './utils/visibility';
import './utils/shopping_cart';
import './module_loader';

// Components
// ----------------------------------

import './components/clipboard_widget';
import './components/add_to_cart';
import './components/store_location';
import './components/credit_card_input';
import './components/gtag_tracking';

// Defaults
// ----------------------------------

$(() => {
  const $body = $(document.body);
  const $hamburger = $('.hamburger');

  const toggleMenu = event => {
    if (event) {
      event.preventDefault();
    }
    $(window).scrollTop(0);

    if ($body.hasClass('navside-open')) {
      $body.removeClass('navside-open');
      $body.addClass('navside-closed');
    } else {
      $body.addClass('navside-open');
      $body.removeClass('navside-closed');
    }
  };

  $hamburger.on('click', toggleMenu);
  $('.navside-backdrop').on('click', toggleMenu);
  $('.navside-close').on('click', toggleMenu);

  $('[data-toggle="tooltip"]').tooltip();
  $('[data-toggle="popover"]').popover()

});
